import React, { useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";
import logo from "../assets/images/deviops_logo.png";
import Breadcrumb from "../components/Breadcrumb";
import StockOutService from "../services/StockOutService";
import ProjectService from "../services/ProjectService";
import ItemsService from "../services/ItemsServices";
import UomService from "../services/UomService";
import StorageService from "../services/StorageService";
import Loading from "../components/loading";
import usePermission from "../utils/UsePermission";
import ScreenData from "../config/ScreenData";
import UnAuthorized from "../views/Unathorized";
import ReactPaginate from "react-paginate";
import MessageDialog from "../components/MessageDialog";
import utility from "../utils/utility";


export default function ViewStockOut() {
  const companyName = StorageService.activeCompany()?.companyName || "";
  const companyId = StorageService.activeCompany()?.companyId;
  const employeeId = StorageService.loginData()?.employeeId;
  const roleId = StorageService.loginData()?.roleId;

  const [stockOuts, setStockOuts] = useState([]);
  const [selected, setSelected] = useState([]);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  const [loading, setLoading] = useState(true);
  const [header, setHeader] = useState(null);
  const [projectList, setProjectList] = useState([]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const pRes = await ProjectService.getActive(companyId);
        const pData = pRes?.data || pRes || [];
        setProjectList(Array.isArray(pData) ? pData : []);
      } catch (e) {
        console.error("Failed to load projects:", e);
      }
    };
    if (companyId) {
      fetchProjects();
    }
  }, [companyId]);

  const formatProjectDisplay = (project) => {
    if (!project) return "-";
    let projObj = project;
    if (typeof project === "string" || typeof project === "number") {
      const match =
        projectList.find(
          (p) =>
            String(p.id) === String(project) ||
            String(p.projectId) === String(project) ||
            p.projectName === project
        ) || {};
      projObj = Object.keys(match).length ? match : { projectName: String(project) };
    }

    const projectId = projObj.projectId || projObj.id;
    const matchedProject =
      (projectId &&
        projectList.find(
          (p) => String(p.id) === String(projectId) || String(p.projectId) === String(projectId)
        )) ||
      (projObj.projectName &&
        projectList.find((p) => p.projectName === projObj.projectName)) ||
      {};

    const projectName =
      projObj.projectName || projObj.name || matchedProject.projectName || "";
    const categoryName =
      projObj.projectCategoryName ||
      projObj.categoryName ||
      projObj.category ||
      matchedProject.projectCategoryName ||
      matchedProject.categoryName ||
      matchedProject.category ||
      "";
    const projectCode =
      projObj.projectCode || matchedProject.projectCode || "";
    const categoryInitial = String(categoryName).trim().charAt(0).toUpperCase();

    if (projectName) {
      if (categoryInitial) {
        return `${categoryInitial}*${projectName}`;
      }
      if (projectCode) {
        const codeInitial = String(projectCode).trim().charAt(0).toUpperCase();
        return `${codeInitial}*${projectName}`;
      }
      return projectName;
    }
    if (projectCode) {
      const codeInitial = String(projectCode).trim().charAt(0).toUpperCase();
      return `${codeInitial}*`;
    }
    return categoryInitial ? `${categoryInitial}*` : "-";
  };


  // APPROVE
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [approveItem, setApproveItem] = useState(null);
  const [approveNote, setApproveNote] = useState("");

  // REJECT
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectItem, setRejectItem] = useState(null);
  const [rejectNote, setRejectNote] = useState("");

  // CANCEL
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelItem, setCancelItem] = useState(null);


  const [popup, setPopup] = useState(false);
  const [detailRows, setDetailRows] = useState([]);
  const [popupLoading, setPopupLoading] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  // const [projectMap, setProjectMap] = useState({});
  // const [storeMap, setStoreMap] = useState({});
  // const [locationMap, setLocationMap] = useState({});
  const [itemMap, setItemMap] = useState({});
  const [uomMap, setUomMap] = useState({});

  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [allStockOuts, setAllStockOuts] = useState([]);
  const [statusFilter, setStatusFilter] = useState("all");
  const [searchText, setSearchText] = useState("");
  const [search, setSearch] = useState("");
  const itemsPerPage = 10;

  useEffect(() => {

    const delayDebounce = setTimeout(() => {

      setCurrentPage(1);
      setSearch(searchText);

    }, 400);

    return () => clearTimeout(delayDebounce);

  }, [searchText]);

  useEffect(() => {
    setCurrentPage(1);
  }, [statusFilter]);

  // const messageTimer = useRef(null);
  const navigate = useNavigate();

  const printRef = useRef();

  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: "Material-Outward-Slip"
  });

  // const showMessage = (text, type = "error") => {
  //   setMessage(text);
  //   setMsgType(type);
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  //   messageTimer.current = setTimeout(() => setMessage(""), 4000);
  // };

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
  };

  const { permission, can } = usePermission(
    ScreenData.Stock_Out,
    showMessage
  );

  useEffect(() => {

    if (permission === null) return;

    if (permission.canView !== 1) {
      setLoading(false);
      return;
    }
    loadAll();
    // return () => messageTimer.current && clearTimeout(messageTimer.current);
  }, [companyId, employeeId, roleId, currentPage, permission, search, statusFilter]);

  useEffect(() => {
    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    setStockOuts(allStockOuts.slice(start, end));
  }, [allStockOuts, currentPage]);

  // const loadAll = async () => {
  //   try {
  //     setLoading(true);

  //     const res = await StockOutService.getAll(companyId);
  //     const rows = res?.data?.data || [];

  //     setStockOuts(rows);
  //     setSelectedId(null);
  //     // setSelected((prev) =>
  //     //   prev.filter((id) => rows.some((r) => r.id === id))
  //     // );
  //   } catch (err) {
  //     console.error("LOAD ERROR:", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  const loadAll = async () => {
    try {

      setLoading(true);

      const res = await StockOutService.getAll(
        companyId,
        employeeId,
        roleId,
        1,
        1000,
        search,
        statusFilter
      );

      const rows = res?.data?.data || [];

      const sortedRows = [...rows].sort((a, b) => b.id - a.id);

      setAllStockOuts(sortedRows);
      const totalPages = Math.max(1, Math.ceil(sortedRows.length / itemsPerPage));
      setPageCount(totalPages);
      const safePage = Math.min(currentPage, totalPages);
      if (safePage !== currentPage) {
        setCurrentPage(safePage);
      }
      const start = (safePage - 1) * itemsPerPage;
      const end = start + itemsPerPage;
      setStockOuts(sortedRows.slice(start, end));
      setSelectedId(null);

    } catch (err) {

      console.error("LOAD ERROR:", err);

    } finally {

      setLoading(false);

    }
  };



  // const handleSelect = (id) =>
  //   setSelected((prev) =>
  //     prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
  //   );

  const handleAdd = () => navigate("/cpnl/stockout/add");

  const handleModify = () => {

    if (!selectedId) {
      return showMessage("Please select one record to modify.");
    }

    const selectedRecord = stockOuts.find(s => s.id === selectedId);

    if (!selectedRecord) {
      return showMessage("Selected record not found.");
    }

    if (selectedRecord.status !== "pending") {
      return showMessage("Only PENDING records can be modified.");
    }

    navigate(`/cpnl/stockout/add/${selectedId}`);
  };

  const handleView = () => {
    if (!selectedId) return showMessage("Please select one record to view details.");
    loadPopup(selectedId);
  };


  const submitApprove = async () => {

    if (!approveNote.trim()) {
      showMessage("Please enter approval note");
      return;
    }

    try {

      await StockOutService.approve(approveItem.id, {
        approvedBy: employeeId,
        approvedNotes: approveNote
      });

      setStockOuts(prev =>
        prev.map(r =>
          r.id === approveItem.id ? { ...r, status: "approved" } : r
        )
      );

      showMessage("StockOut approved successfully", "success");
      setShowApproveModal(false);

    } catch (err) {
      console.error("Approve error:", err.response?.data || err);
      showMessage(err.response?.data?.message || "Approval failed");
    }
  };

  const submitReject = async () => {

    if (!rejectNote.trim()) {
      showMessage("Please enter rejection note");
      return;
    }

    try {

      await StockOutService.reject(rejectItem.id, {
        rejectedBy: employeeId,
        rejectedNotes: rejectNote
      });

      setStockOuts(prev =>
        prev.map(r =>
          r.id === rejectItem.id ? { ...r, status: "rejected" } : r
        )
      );

      showMessage("StockOut rejected successfully", "success");
      setShowRejectModal(false);

    } catch (err) {
      console.error("Reject error:", err.response?.data || err);
      showMessage(err.response?.data?.message || "Rejection failed");
    }
  };

  const submitCancel = async () => {

    try {

      await StockOutService.cancel(cancelItem.id, {
        cancelledBy: employeeId
      });

      setStockOuts(prev =>
        prev.map(r =>
          r.id === cancelItem.id ? { ...r, status: "cancelled" } : r
        )
      );

      showMessage("StockOut cancelled successfully", "success");
      setShowCancelModal(false);

    } catch (err) {
      console.error("Cancel error:", err.response?.data || err);
      showMessage(err.response?.data?.message || "Cancel failed");
    }
  };




  const loadPopup = async (id) => {
    try {
      setPopup(true);
      setPopupLoading(true);

      let localItemMap = { ...itemMap };

      // ✅ Load ITEM master only (UOM is already text in DB)
      if (!Object.keys(localItemMap).length) {
        const itemRes = await ItemsService.getAllItems();

        const iMap = {};
        (itemRes?.data || itemRes || []).forEach((i) => {
          const key = String(i.id ?? i.itemId ?? i.item_id ?? "");
          iMap[key] = {
            name: i.itemName ?? i.name ?? "",
            categoryName: i.itemCategoryName ?? i.categoryName ?? i.itemCategory ?? "",
            description: i.itemDescription ?? i.description ?? ""
          };
        });

        setItemMap(iMap);
        localItemMap = iMap;
      }

      // 🔹 Get stock out by id
      const res = await StockOutService.getById(id);
      const payload = res?.data?.data ?? res?.data ?? res ?? {};
      const selectedRecord =
        stockOuts.find((r) => r.id === id) ||
        allStockOuts.find((r) => r.id === id) ||
        {};
      const mergedHeader = {
        ...selectedRecord,
        ...payload,
        projectName: payload.projectName || selectedRecord.projectName || "",
        projectCode: payload.projectCode || selectedRecord.projectCode || "",
        projectCategoryName:
          payload.projectCategoryName ||
          selectedRecord.projectCategoryName ||
          "",
        projectCategoryCode:
          payload.projectCategoryCode ||
          selectedRecord.projectCategoryCode ||
          "",
      };
      setHeader(mergedHeader);


      // backend returns: stockOut.details
      const details = payload.details || [];

      const mapped = (Array.isArray(details) ? details : []).map((d) => {
        const itemIdKey = String(d.itemId ?? "");
        const item = localItemMap[itemIdKey] || {};

        return {
          itemId: d.itemId,
          itemCode: d.itemCode ?? "",
          itemName: item.name ?? "",
          itemCategoryName: d.itemCategoryName || d.categoryName || d.itemCategory || item.categoryName || "",
          itemDescription: item.description ?? "",
          UOM: d.UOM,
          quantity: d.quantity,
        };
      });


      setDetailRows(mapped);
    } catch (err) {
      console.error("POPUP LOAD ERROR:", err);
      setDetailRows([]);
    } finally {
      setPopupLoading(false);
    }
  };


  if (permission === null) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  if (!permission || permission.canView !== 1) {
    return <UnAuthorized />;
  }


  const formatEmployee = (name, code) => {
    if (name && code) return `${name} (${code})`;
    return name || code || "-";
  };

  return (
    <>
      <Breadcrumb pageTitle="Stock Out" secondTitle="Inventory" />

      {/* {message && (
        <div
          className={`alert alert-${msgType === "error" ? "danger" : msgType
            }`}
        >
          {message}
        </div>
      )} */}

      <MessageDialog
        message={message}
        type={msgType}
        setMessage={setMessage}
        setMsgType={setMsgType}
      />

      <div className="card p-3 shadow-sm">
        <div className="mb-3 pb-2 border-bottom d-flex justify-content-between align-items-center flex-wrap gap-2">
          {can("canAdd") && (
            <button className="btn btn-success me-2" onClick={handleAdd}>
              + Add
            </button>
          )}
          {can("canModify") && (
            <button
              className="btn btn-warning me-2"
              onClick={handleModify}
              disabled={
                loading ||
                !selectedId ||
                stockOuts.find(s => s.id === selectedId)?.status !== "pending"
              }
            >
              <i className="ti ti-edit me-1"></i> Modify
            </button>
          )}
          {can("canView") && (
            <>
              <button className="btn btn-primary me-2" onClick={handleView}>
                <i className="ti ti-eye me-1"></i>
                View
              </button>

              <select
                className="form-select d-inline w-auto"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="all">All</option>
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
                <option value="cancelled">Cancelled</option>
              </select>
            </>
          )}

          <div className="d-flex align-items-center ms-auto">
            <div className="position-relative">

              <input
                type="text"
                className="form-control pe-5"
                placeholder="Search Project / Voucher No"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{ width: "280px" }}
              />

              <i
                className="ti ti-search position-absolute"
                style={{
                  right: "15px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#6c757d"
                }}
              ></i>

            </div>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-bordered">
            <thead className="table-light">
              <tr>
                <th>Select</th>
                <th>Voucher No</th>
                <th>Transaction Date</th>
                <th>Project</th>
                <th>From Store</th>
                <th>To Location</th>
                {/* <th>Voucher No</th> */}
                <th>Transporter</th>
                {/* <th>Transaction Date</th> */}
                <th>Receiver Name</th>
                <th>Notes</th>
                <th>Status</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {stockOuts.map((s) => (
                <tr key={s.id}>
                  <td>
                    <input
                      type="radio"
                      name="stockOutSelect"
                      checked={selectedId === s.id}
                      onChange={() => setSelectedId(s.id)}
                    />
                  </td>
                  <td>{s.vocherNo ?? s.voucherNo ?? "-"}</td>
                  <td>
                    {s.transactionDate || s.transaction_date
                      ? utility.formatDateDDMMMYYYY(
                        s.transactionDate || s.transaction_date
                      )
                      : "-"}
                  </td>
                  <td>{formatProjectDisplay(s)}</td>
                  <td>{s.storeName}</td>
                  <td>{s.locationName ?? s.locationId}</td>
                  {/* <td>{s.vocherNo ?? s.voucherNo ?? "-"}</td> */}
                  <td>{s.transporterName}</td>
                  {/* <td>
  {s.transactionDate || s.transaction_date
    ? new Date(
        s.transactionDate || s.transaction_date
      ).toLocaleDateString("en-GB")
    : "-"}
                  </td> */}
                  <td>{s.receiverName}</td>

                  <td>{s.stockOutNotes}</td>
                  <td>
                    <span
                      className={`badge ${s.status === "pending"
                        ? "bg-info text-dark"
                        : s.status === "approved"
                          ? "bg-success"
                          : s.status === "rejected"
                            ? "bg-danger"
                            : s.status === "cancelled"
                              ? "bg-dark"
                              : "bg-secondary"
                        }`}
                    >
                      {s.status}
                    </span>
                  </td>
                  <td className="text-center d-flex justify-content-center gap-2">

                    {can("canApprove") && (
                      <button
                        className="btn btn-success btn-sm"
                        title="Approve"
                        disabled={s.status !== "pending"}
                        onClick={() => {
                          setApproveItem(s);
                          setApproveNote("");
                          setShowApproveModal(true);
                        }}
                      >
                        <i className="ti ti-circle-check"></i>
                      </button>
                    )}

                    {can("canReject") && (
                      <button
                        className="btn btn-danger btn-sm"
                        title="Reject"
                        disabled={s.status !== "pending"}
                        onClick={() => {
                          setRejectItem(s);
                          setRejectNote("");
                          setShowRejectModal(true);
                        }}
                      >
                        <i className="ti ti-circle-x"></i>
                      </button>
                    )}

                    {can("canCancel") && (
                      <button
                        className="btn btn-secondary btn-sm"
                        title="Cancel"
                        disabled={s.status !== "pending" || Number(s.createdBy) !== Number(employeeId)}
                        onClick={() => {
                          setCancelItem(s);
                          setShowCancelModal(true);
                        }}
                      >
                        <i className="ti ti-cancel"></i>
                      </button>
                    )}

                  </td>
                </tr>
              ))}

              {!loading && stockOuts.length === 0 && (
                <tr>
                  <td colSpan="10" className="text-center">
                    No records found
                  </td>
                </tr>
              )}

              {loading && (
                <tr>
                  <td colSpan="9" className="text-center py-4">
                    <Loading />
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <ReactPaginate
            forcePage={Math.max(0, Math.min(currentPage - 1, Math.max(pageCount - 1, 0)))}
            onPageChange={(e) => setCurrentPage(e.selected + 1)}
            pageCount={Math.max(1, pageCount)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            previousLabel="< Previous"
            nextLabel="Next >"
            containerClassName="pagination-container"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            nextClassName="page-item"
            activeClassName="active"
          />
        </div>
      </div>

      {/* POPUP */}
      {popup && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.5)",
          }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Stock Out Details</h5>
                <button className="btn-close" onClick={() => setPopup(false)} />
              </div>

              {/* <div className="modal-body">
                {popupLoading ? (
                  <div className="text-center p-3">Loading...</div>
                ) : (
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th>UOM</th>
                        <th>Qty</th>
                      </tr>
                    </thead>

                    <tbody>
                      {detailRows.map((d, i) => (
                        <tr key={i}>
                          <td>
  {d.itemCode ?? itemMap[String(d.itemId)] ?? ""}
</td>

                          
                          <td>{d.UOM}</td>
                          <td>{d.quantity}</td>
                        </tr>
                      ))}

                      {detailRows.length === 0 && (
                        <tr>
                          <td colSpan="3" className="text-center">
                            No Records Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div> */};

              <div className="modal-body">
                {popupLoading ? (
                  <div className="text-center p-4">
                    <Loading />
                  </div>
                ) : (
                  <>
                    {header && (
                      <div className="row mb-3">
                        {/* <div className="col-md-4">
                          <strong>Voucher No:</strong> {header.vocherNo || header.voucherNo || "-"}
                        </div>
                        <div className="col-md-4">
                          <strong>Transaction Date:</strong>{" "}
                          {header.transactionDate || header.transaction_date
                            ? new Date(
                              header.transactionDate || header.transaction_date
                            ).toLocaleDateString("en-GB")
                            : "-"}
                        </div>

                        <div className="col-md-6 mt-2">
                          <strong>Project:</strong> {header.projectName || "-"}
                        </div>
                        <div className="col-md-6 mt-2">
                          <strong>Store:</strong> {header.storeName || "-"}
                        </div>

                        <div className="col-md-6 mt-2">
                          <strong>Transporter:</strong> {header.transporterName || "-"}
                        </div>

                        <div className="col-md-6 mt-2">
                          <strong>Receiver Name:</strong> {header.receiverName || "-"}
                          </div>
                          
                          
                            <div className="col-md-6 mt-2">
                              <strong>Vehicle No:</strong> {header.vehicleNo || "-"}
                            </div>
                          
                            <div className="col-md-6 mt-2">
                              <strong>Notes:</strong> {header.stockOutNotes || header.notes || "-"}
                            </div> */}

                        <div className="row mb-3">

                          {/* Row 1: Transaction Date & Voucher Number (Bold) */}
                          <div className="col-md-6">
                            <strong>Transaction Date:</strong>{" "}
                            <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>
                              {header.transactionDate || header.transaction_date
                                ? utility.formatDateDDMMMYYYY(
                                  header.transactionDate || header.transaction_date
                                )
                                : "-"}
                            </span>
                          </div>
                          <div className="col-md-6">
                            <strong>Voucher Number:</strong>{" "}
                            <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>
                              {header.vocherNo || header.voucherNo || "-"}
                            </span>
                          </div>

                          {/* Row 2 */}
                          <div className="col-md-6 mt-2">
                            <strong>Project Name:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{formatProjectDisplay(header)}</span>
                          </div>
                          <div className="col-md-6 mt-2">
                            <strong>From Store:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{header.storeName || "-"}</span>
                          </div>

                          {/* Row 3 */}
                          <div className="col-md-6 mt-2">
                            <strong>To Location:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{header.locationName || "-"}</span>
                          </div>
                          <div className="col-md-6 mt-2">
                            <strong>Receiver Name:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{header.receiverName || "-"}</span>
                          </div>

                          {/* Row 4 */}
                          <div className="col-md-6 mt-2">
                            <strong>Transporter:</strong> {header.transporterName || "-"}
                          </div>
                          <div className="col-md-6 mt-2">
                            <strong>Vehicle Number:</strong> {header.vehicleNo || "-"}
                          </div>

                          {/* Row 5 */}
                          <div className="col-md-6 mt-2">
                            <strong>Created By:</strong>{" "}
                            {formatEmployee(header.createdByName, header.createdByCode)}
                          </div>
                          <div className="col-md-6 mt-2">
                            <strong>Status:</strong>{" "}
                            <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>
                              {header.status ? header.status.toUpperCase() : "PENDING"}
                            </span>
                          </div>

                          {/* Conditional Action Notes */}
                          {header.status?.toLowerCase() === "approved" && (
                            <>
                              <div className="col-md-6 mt-2">
                                <strong>Approved By:</strong>{" "}
                                {formatEmployee(header.approvedByName, header.approvedByCode)}
                              </div>
                              <div className="col-md-6 mt-2">
                                <strong>Approved Notes:</strong> {header.approvedNotes || "-"}
                              </div>
                            </>
                          )}

                          {header.status?.toLowerCase() === "rejected" && (
                            <>
                              <div className="col-md-6 mt-2">
                                <strong>Rejected By:</strong>{" "}
                                {formatEmployee(header.rejectedByName, header.rejectedByCode)}
                              </div>
                              <div className="col-md-6 mt-2">
                                <strong>Rejected Notes:</strong> {header.rejectedNotes || "-"}
                              </div>
                            </>
                          )}

                          {header.status?.toLowerCase() === "cancelled" && (
                            <>
                              <div className="col-md-6 mt-2">
                                <strong>Cancelled By:</strong>{" "}
                                {formatEmployee(header.cancelledByName, header.cancelledByCode)}
                              </div>
                              <div className="col-md-6 mt-2">
                                <strong>Cancelled Notes:</strong> {header.cancelledNotes || "-"}
                              </div>
                            </>
                          )}

                          <div className="col-md-12 mt-2">
                            <strong>Notes:</strong> {header.stockOutNotes || header.notes || "-"}
                          </div>

                        </div>


                      </div>
                    )}

                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Item Category</th>
                          <th>Item</th>
                          <th>UOM</th>
                          <th>Qty</th>
                        </tr>
                      </thead>

                      <tbody>
                        {detailRows.map((d, i) => (
                          <tr key={i}>
                            <td>{d.itemCategoryName || "-"}</td>
                            <td><span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{d.itemCode ?? itemMap[String(d.itemId)] ?? ""}</span></td>
                            <td>{d.UOM}</td>
                            <td><span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{d.quantity}</span></td>
                          </tr>
                        ))}

                        {detailRows.length === 0 && (
                          <tr>
                            <td colSpan="4" className="text-center">
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    {/* PRINT TEMPLATE */}
                    <div style={{ display: "none" }}>
                      <div ref={printRef} className="print-container">


                        <div className="print-top-header">
                          <div className="print-top-left">
                            <img src={logo} alt="Logo" className="print-logo" />
                            <span className="print-company">{companyName}</span>
                          </div>
                          <div className="print-top-right">
                            <b>Printed Date:</b> {utility.formatExportDateTime(new Date())}
                          </div>
                        </div>

                        <h3 className="print-title">Material Outward Slip</h3>


                        <table className="print-header">
                          <tbody>

                            <tr className="project-store-row">
                              <td><b>Project Name:</b> {formatProjectDisplay(header)}</td>
                              <td><b>From Store:</b> {header?.storeName || "-"}</td>
                            </tr>

                            <tr>
                              <td><b>To Location:</b> {header?.locationName || "-"}</td>
                              <td><b>Voucher No:</b> {header?.vocherNo || "-"}</td>
                            </tr>

                            <tr>
                              <td><b>Transporter:</b> {header?.transporterName || "-"}</td>
                              <td><b>Vehicle Number:</b> {header?.vehicleNo || "-"}</td>
                            </tr>

                            <tr>
                              <td>
                                <b>Transaction Date:</b>{" "}
                                {header.transactionDate
                                  ? utility.formatDateDDMMMYYYY(header.transactionDate)
                                  : ""}
                              </td>
                              <td><b>Notes:</b> {header?.stockOutNotes || header?.notes || "-"}</td>
                            </tr>

                            <tr>
                              <td><b>Status:</b> {header?.status ? header.status.toUpperCase() : "PENDING"}</td>
                              <td><b>Created By:</b> {formatEmployee(header?.createdByName, header?.createdByCode)}</td>
                            </tr>

                            {header?.status?.toLowerCase() === "approved" && (
                              <tr>
                                <td><b>Approved By:</b> {formatEmployee(header?.approvedByName, header?.approvedByCode)}</td>
                                <td><b>Approved Notes:</b> {header?.approvedNotes || "-"}</td>
                              </tr>
                            )}

                            {header?.status?.toLowerCase() === "rejected" && (
                              <tr>
                                <td><b>Rejected By:</b> {formatEmployee(header?.rejectedByName, header?.rejectedByCode)}</td>
                                <td><b>Rejected Notes:</b> {header?.rejectedNotes || "-"}</td>
                              </tr>
                            )}

                            {header?.status?.toLowerCase() === "cancelled" && (
                              <tr>
                                <td><b>Cancelled By:</b> {formatEmployee(header?.cancelledByName, header?.cancelledByCode)}</td>
                                <td><b>Cancelled Notes:</b> {header?.cancelledNotes || "-"}</td>
                              </tr>
                            )}

                          </tbody>
                        </table>


                        <table className="print-table">
                          <thead>
                            <tr>
                              <th className="text-center">S.No</th>
                              <th className="text-start">Item Category</th>
                              <th className="text-start">Item Code</th>
                              <th className="text-start">UOM</th>
                              <th className="text-end">Qty</th>
                              <th className="text-start">Remarks</th>
                            </tr>
                          </thead>

                          <tbody>
                            {detailRows.map((d, i) => (
                              <tr key={i}>
                                <td className="text-center">{i + 1}</td>
                                <td className="text-start">{d.itemCategoryName || "-"}</td>
                                <td className="text-start">{d.itemCode}</td>
                                <td className="text-start">{d.UOM}</td>
                                <td className="text-end">{d.quantity}</td>
                                <td className="text-start"></td>
                              </tr>
                            ))}
                          </tbody>
                        </table>


                        <div style={{ marginTop: "60px", display: "flex", justifyContent: "space-between" }}>
                          <div>Store Incharge Signature</div>
                          <div>Receiver Signature</div>
                          <div>Approved By  Signature</div>
                        </div>

                      </div>
                    </div>

                  </>
                )}
              </div>
              <div className="modal-footer">

                <button
                  className="btn btn-success me-2"
                  onClick={handlePrint}
                >
                  <i className="ti ti-printer me-1"></i>
                  Print
                </button>

                <button
                  className="btn btn-secondary"
                  onClick={() => setPopup(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* {showApproveModal && (
<div className="modal-overlay">
<div className="modal-box">

<h5>Approve Stock Out</h5>

<div className="mb-3">
<label>Approval Note</label>
<textarea
className="form-control"
rows="3"
value={approveNote}
onChange={(e)=>setApproveNote(e.target.value)}
/>
</div>

<div className="d-flex justify-content-end gap-2">

<button
className="btn btn-secondary"
onClick={()=>setShowApproveModal(false)}
>
Cancel
</button>

<button
className="btn btn-success"
onClick={submitApprove}
>
Approve
</button>

</div>

</div>
</div>
)}

{showRejectModal && (
<div className="modal-overlay">
<div className="modal-box">

<h5>Reject Stock Out</h5>

<div className="mb-3">
<label>Rejection Note</label>
<textarea
className="form-control"
rows="3"
value={rejectNote}
onChange={(e)=>setRejectNote(e.target.value)}
/>
</div>

<div className="d-flex justify-content-end gap-2">

<button
className="btn btn-secondary"
onClick={()=>setShowRejectModal(false)}
>
Cancel
</button>

<button
className="btn btn-danger"
onClick={submitReject}
>
Reject
</button>

</div>

</div>
</div>
)}

{showCancelModal && (
<div className="modal-overlay">
<div className="modal-box">

<h5>Cancel Stock Out</h5>

<p>Are you sure you want to cancel this record?</p>

<div className="d-flex justify-content-end gap-2">

<button
className="btn btn-secondary"
onClick={()=>setShowCancelModal(false)}
>
No
</button>

<button
className="btn btn-dark"
onClick={submitCancel}
>
Yes Cancel
</button>

</div>

</div>
</div>
)} */}

      {showApproveModal && (
        <div style={{
          position: "fixed",
          top: 0, left: 0,
          width: "100%", height: "100%",
          background: "rgba(0,0,0,0.5)",
          zIndex: 999
        }}>
          <div style={{
            position: "fixed",
            top: "50%", left: "50%",
            transform: "translate(-50%,-50%)",
            width: "450px",
            background: "#fff",
            padding: "20px",
            borderRadius: "8px"
          }}>
            <h5>Approve Stock Out</h5>

            <div className="mb-2">
              <label>Approval Date</label>
              <input
                className="form-control"
                value={utility.formatDateDDMMMYYYY(new Date())}
                disabled
              />
            </div>

            <div className="mb-3">
              <label>Approval Note</label>
              <textarea
                className="form-control"
                rows="3"
                value={approveNote}
                onChange={(e) => setApproveNote(e.target.value)}
              />
            </div>

            <div className="d-flex justify-content-end gap-2">

              <button
                className="btn btn-secondary"
                onClick={() => setShowApproveModal(false)}
              >
                Cancel
              </button>

              <button
                className="btn btn-success"
                onClick={submitApprove}
              >
                Approve
              </button>

            </div>
          </div>
        </div>
      )}

      {showRejectModal && (
        <div style={{
          position: "fixed",
          top: 0, left: 0,
          width: "100%", height: "100%",
          background: "rgba(0,0,0,0.5)",
          zIndex: 999
        }}>
          <div style={{
            position: "fixed",
            top: "50%", left: "50%",
            transform: "translate(-50%,-50%)",
            width: "450px",
            background: "#fff",
            padding: "20px",
            borderRadius: "8px"
          }}>
            <h5>Reject Stock Out</h5>

            <div className="mb-2">
              <label>Rejection Date</label>
              <input
                className="form-control"
                value={utility.formatDateDDMMMYYYY(new Date())}
                disabled
              />
            </div>

            <div className="mb-3">
              <label>Rejection Note</label>
              <textarea
                className="form-control"
                rows="3"
                value={rejectNote}
                onChange={(e) => setRejectNote(e.target.value)}
              />
            </div>

            <div className="d-flex justify-content-end gap-2">

              <button
                className="btn btn-secondary"
                onClick={() => setShowRejectModal(false)}
              >
                Cancel
              </button>

              <button
                className="btn btn-danger"
                onClick={submitReject}
              >
                Reject
              </button>

            </div>
          </div>
        </div>
      )}

      {showCancelModal && (
        <div style={{
          position: "fixed",
          top: 0, left: 0,
          width: "100%", height: "100%",
          background: "rgba(0,0,0,0.5)",
          zIndex: 999
        }}>
          <div style={{
            position: "fixed",
            top: "50%", left: "50%",
            transform: "translate(-50%,-50%)",
            width: "400px",
            background: "#fff",
            padding: "20px",
            borderRadius: "8px"
          }}>
            <h5>Cancel Stock Out</h5>

            <p>Are you sure you want to cancel this record?</p>

            <div className="d-flex justify-content-end gap-2">

              <button
                className="btn btn-secondary"
                onClick={() => setShowCancelModal(false)}
              >
                No
              </button>

              <button
                className="btn btn-dark"
                onClick={submitCancel}
              >
                Yes Cancel
              </button>

            </div>
          </div>
        </div>
      )}
    </>
  );
}